import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/components/shared/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
